import Layout from '@/components/Layout';
import FirstPage from '@/components/FirstPage';

import HomePage from '@/components/HomePage';
import WomanPage from '@/components/WomanPage';
import ManPage from '@/components/ManPage';
import KnowHowPage from '@/components/KnowHowPage';
import GlovesSportPage from '@/components/GlovesSportPage';
import StoryPage from '@/components/StoryPage';
import CustomMadePage from '@/components/CustomMadePage';
import PressPage from '@/components/PressPage';
import FurnituresPage from '@/components/FurnituresPage';
import OrderPage from '@/components/OrderPage';
import CartPage from '@/components/CartPage';
import ShippingAddressPage from '@/components/ShippingAddressPage';
import BillingAddressPage from '@/components/BillingAddressPage';
import SummaryPage from '@/components/SummaryPage';

import FabricationPage from '@/components/FabricationPage';
import LegalesPage from '@/components/LegalesPage';
import ContactPage from '@/components/ContactPage';

export default [
  {
    path: '/',
    name: 'Root',
    component: FirstPage,
  },
  {
    path: '/fr',
    component: Layout,
    props: {
      lang: 'fr',
    },
    children: [
      {
        path: '',
        name: 'HomeFR',
        component: HomePage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/femme',
        name: 'WomanFR',
        component: WomanPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/homme',
        name: 'ManFR',
        component: ManPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/savoir-faire',
        name: 'KnowHowFR',
        component: KnowHowPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/fabrication',
        name: 'FabricationFR',
        component: FabricationPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/gants-et-sport',
        name: 'GlovesAndSportsFR',
        component: GlovesSportPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/une-histoire',
        name: 'StoryFR',
        component: StoryPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/sur-mesure',
        name: 'CustomMadeFR',
        component: CustomMadePage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/presse',
        name: 'PressFR',
        component: PressPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/accessoires',
        name: 'FurnituresFR',
        component: FurnituresPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/acheter',
        name: 'OrderFR',
        component: OrderPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/panier',
        name: 'CheckoutFR',
        component: CartPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/livraison',
        name: 'ShippingFR',
        component: ShippingAddressPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/facturation',
        name: 'BillingFR',
        component: BillingAddressPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/recapitulatif',
        name: 'SummaryFR',
        component: SummaryPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/mentions-legales',
        name: 'LegalesFR',
        component: LegalesPage,
        props: {
          lang: 'fr',
        },
      },
      {
        path: '/contact',
        name: 'ContactFR',
        component: ContactPage,
        props: {
          lang: 'fr',
        },
      },
    ],
  },

  {
    path: '/en',
    component: Layout,
    props: {
      lang: 'en',
    },
    children: [
      {
        path: '',
        name: 'HomeEN',
        component: HomePage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/woman',
        name: 'WomanEN',
        component: WomanPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/man',
        name: 'ManEN',
        component: ManPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/know-how',
        name: 'KnowHowEN',
        component: KnowHowPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/fabrication-shop',
        name: 'FabricationEN',
        component: FabricationPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/gloves-and-sports',
        name: 'GlovesAndSportsEN',
        component: GlovesSportPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/story',
        name: 'StoryEN',
        component: StoryPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/custom-made',
        name: 'CustomMadeEN',
        component: CustomMadePage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/furnitures',
        name: 'FurnituresEN',
        component: FurnituresPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/order',
        name: 'OrderEN',
        component: OrderPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/cart',
        name: 'CheckoutEN',
        component: CartPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/shipping',
        name: 'ShippingEN',
        component: ShippingAddressPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/billing',
        name: 'BillingEN',
        component: BillingAddressPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/summary',
        name: 'SummaryEN',
        component: SummaryPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/legal-terms',
        name: 'LegalesEN',
        component: LegalesPage,
        props: {
          lang: 'en',
        },
      },
      {
        path: '/contact-us',
        name: 'ContactEN',
        component: ContactPage,
        props: {
          lang: 'en',
        },
      },

    ],
  },

];



// WEBPACK FOOTER //
// ./src/router/routes.js